export default __webpack_public_path__ + "static/media/logoLine.8a29e01b.webp";